export const tableInitialState = {
  organizations: [],
  customers: [],
  branches: [],
  page: 1
}

export const tableReducer = (state, action) => {
  if (action.page) {
    return {
      ...state,
      page: action.page
    }
  } else if (action.organizations) {
    return {
      ...state,
      organizations: action.organizations
    }
  } else if (action.customers) {
    return {
      ...state,
      customers: action.customers
    }
  } else if (action.branches) {
    return {
      ...state,
      branches: action.branches
    }
  }
  return state
}
